import { HttpTypes } from '@/types';
import { ICustomer, ICustomerData, ICustomerOrder } from '@/types/customer';
import { AxiosInstance } from 'axios';

class Products {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async orderList(
    id: string,
    queryParams: unknown
  ): Promise<HttpTypes.IResponse<ICustomerOrder[]>> {
    const result = await this.client.get(`/customer/orders/history/${id}`, {
      params: queryParams,
    });

    return result.data;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<ICustomerData[]>> {
    const result = await this.client.get('/customer/list', {
      params: queryParams,
    });
    return result.data;
  }

  async listTimeline(queryParams: {
    customer_id: string;
  }): Promise<HttpTypes.AdminCustomerTimelineResponse> {
    const result = await this.client.get(`/customer/timeline/${queryParams.customer_id}`);
    return result.data;
  }

  async createTimeline(
    data: HttpTypes.AdminCustomerTimelineRequest
  ): Promise<HttpTypes.IResponse<HttpTypes.AdminCustomerTimelineResponse>> {
    const result = await this.client.post('/customer/timeline', data);
    return result.data;
  }

  async deleteTimeline(
    data: Pick<HttpTypes.AdminCustomerTimelineRequest, 'timeline_id'>
  ): Promise<HttpTypes.IResponse<HttpTypes.AdminCustomerTimelineResponse>> {
    const result = await this.client.delete(`/customer/timeline/${data.timeline_id}`);
    return result.data;
  }

  async sendEmailResetPassword(
    customer_id: string
  ): Promise<HttpTypes.AdminCustomerTimelineResponse> {
    const result = await this.client.get(`/customer/reset-password/${customer_id}`);
    return result.data;
  }

  async sendEmail(customer_id: string): Promise<HttpTypes.AdminCustomerTimelineResponse> {
    const result = await this.client.get(`/customer/invitation/${customer_id}`);
    return result.data;
  }

  async sendEmailVerification(
    customer_id: string
  ): Promise<HttpTypes.AdminCustomerTimelineResponse> {
    const result = await this.client.get(`/customer/resend-verification-email/${customer_id}`);
    return result.data;
  }
  async deactiveAccount(
    customer_id: string,
    is_verify: boolean
  ): Promise<HttpTypes.IResponse<HttpTypes.AdminCustomerTimelineResponse>> {
    const result = await this.client.post(`/customer/status/${customer_id}`, {
      is_verify: is_verify,
    });
    return result.data;
  }

  async deleteCustomers(data: { ids: string[] }): Promise<HttpTypes.IResponse<ICustomer>> {
    const result = await this.client.delete('/customer/delete', {
      data,
    });
    return result.data;
  }
}

export default Products;
